import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { LoadingDots } from "../Components/LoadingDots";
import transactionService from "../Services/transactionService";
import moment from "moment";
import { IoClose } from "react-icons/io5";

const SupplierDebit = ({ isOpen, onClose, trigger, setTrigger, supplier }) => {
  const navigate = useNavigate();
  const [file, setFile] = useState();
  const [responseError, setResponseError] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    amount: "",
    date: "",
    note: "",
  });

  const [errors, setErrors] = useState({
    amount: false,
    date: false,
    note: false,
  });

  const [regex, setRegex] = useState({
    amount: /.{1,50}$/,
    date: /.{1,50}$/,
    note: /.{1,50}$/,
  });

  const handleChange = (v, n) => {
    if (n === "date" && v > moment().format("YYYY-MM-DD")) {
      toast.error("Cannot select future date", { id: "1" });
      return;
    }
    setResponseError("");
    if (n === "amount" && v < 0) return;
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      let form = { ...data, supplier_id: supplier, transaction_type: "DEBIT" };
      console.log(form);
      transactionService.create(form).then((res) => {
        setLoading(false);
        toast.success("Transaction Registered Successfully", { id: "2" });
        navigate("/suppliers");
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black  bg-opacity-50 w-[100%] mx-auto">
      <div className="bg-white h-[400px] rounded-3xl p-4">
        <div className="flex justify-end">
          <button
            className="bg-red-500 p-1 rounded-full"
            onClick={() => onClose()}
          >
            <IoClose className="text-white" />
          </button>
        </div>
        <div className="mb-2 mt-4">
          <h1 className="flex justify-center font-bold text-2xl text-secondary">
            Add Payment
          </h1>
        </div>
        <div className="flex flex-col justify-center space-y-3 px-12 py-10">
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-16">
            <div>
              <label
                className={`text-left tracking-wide text-grey-darker text-[0.8rem] font-[600] mb-[3px]`}
              >
                Amount
              </label>
              <input
                value={data.amount}
                name="amount"
                type="number"
                onChange={(e) => handleChange(e.target.value, e.target.name)}
                className={`primary-input ${
                  errors["amount"] ? "border-red-600" : "border-gray-300"
                }`}
              />
            </div>
            <div>
              <label
                className={`text-left tracking-wide text-grey-darker text-[0.8rem] font-[600] mb-[3px]`}
              >
                Date
              </label>
              <input
                value={data.date}
                name="date"
                type="date"
                onChange={(e) => handleChange(e.target.value, e.target.name)}
                placeholder="Date"
                className={`primary-input ${
                  errors["date"] ? "border-red-600" : "border-gray-300"
                }`}
              />
            </div>
          </div>
          <div className="grid grid-cols-1 gap-2 md:gap-20">
            <div>
              <label
                className={`text-left tracking-wide text-grey-darker text-[0.8rem] font-[600] mb-[3px]`}
              >
                Notes
              </label>
              <input
                value={data.notes}
                name="note"
                type="textarea"
                onChange={(e) => handleChange(e.target.value, e.target.name)}
                className={`primary-input ${
                  errors["note"] ? "border-red-600" : "border-gray-300"
                }`}
              />
            </div>
          </div>
          <div className="flex items-center justify-center flex-col pt-10">
            <button
              onClick={() => handleSubmit()}
              className={`button-primary ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={loading}
            >
              <div>Add Record</div>
              {loading ? <LoadingDots /> : ""}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierDebit;
